// Ordered subset of the theme's graphColors used to distinguish tracked competitors.
// Length must stay >= MAX_COMPETITORS (report-settings/tracked-competitors) — with fewer
// colors than the cap, the modulo below wraps and visible competitors share a color.
export const COMPETITOR_COLOR_KEYS = ["green", "orange", "purple", "darkGrey", "yellow"];
export function assignCompetitorColor(index, graphColors) {
    const key = COMPETITOR_COLOR_KEYS[index % COMPETITOR_COLOR_KEYS.length];
    return graphColors[key];
}
